import React, { useState, useEffect } from 'react';
import { 
    Plus, Edit3, Trash2, CheckCircle, AlertTriangle, Hotel 
} from 'lucide-react';
import Sidebar from '../../components/Sidebar';
import API from '../../services/api'; // 👈 Import de ton instance Axios configurée
import '../Dashboard.css';

const CategorieChambre = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({ nom: '', description: '' });

  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [modalConfig, setModalConfig] = useState({ show: false, action: null, message: '', id: null });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await API.get('/hebergement/categories');
      
      // 🛡️ CORRECTION SÉCURISÉE : Extraction garantie d'un tableau
      const rawData = response.data;
      let listCategories = [];
      if (Array.isArray(rawData)) {
        listCategories = rawData;
      } else if (rawData && typeof rawData === 'object') {
        const potentialArray = rawData.categories || rawData.data || rawData.items;
        if (Array.isArray(potentialArray)) {
          listCategories = potentialArray;
        }
      }

      setCategories(listCategories);
    } catch (err) {
      console.error("Erreur chargement catégories chambres:", err);
      showToast("Erreur de chargement des catégories", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nom.trim()) {
      showToast("Le nom de la catégorie est obligatoire", "error");
      return;
    }

    setLoading(true);
    try {
      const payload = { 
        nom: formData.nom.toUpperCase().trim(), 
        description: formData.description.trim() 
      };

      if (editingId) {
        await API.put(`/hebergement/categories/${editingId}`, payload);
        showToast("Catégorie mise à jour avec succès");
      } else {
        await API.post('/hebergement/categories', payload);
        showToast("Catégorie créée avec succès");
      }

      closeForm();
      fetchData();
    } catch (err) {
      console.error("Erreur enregistrement catégorie :", err);
      const errorMsg = err.response?.data?.error || "Erreur lors de l'enregistrement";
      showToast(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (id) => {
    setModalConfig({
      show: true,
      action: () => executeDelete(id),
      message: "Voulez-vous vraiment supprimer cette catégorie de chambre ?",
      id
    });
  };

  const executeDelete = async (id) => {
    setLoading(true);
    try {
      await API.delete(`/hebergement/categories/${id}`);
      showToast("Catégorie supprimée avec succès");
      setModalConfig({ show: false, action: null, message: '', id: null });
      fetchData();
    } catch (err) {
      const errorMsg = err.response?.data?.error || "Impossible de supprimer cette catégorie.";
      showToast(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const closeForm = () => {
    setIsAdding(false);
    setEditingId(null);
    setFormData({ nom: '', description: '' });
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <main style={{ flex: 1, overflowY: 'auto', background: '#f1f5f9', position: 'relative' }}>
        
        {toast.show && (
          <div style={{...toastContainerStyle, background: toast.type === 'success' ? '#10b981' : '#ef4444'}}>
            {toast.type === 'success' ? <CheckCircle size={18}/> : <AlertTriangle size={18}/>}
            {toast.message}
          </div>
        )}

        <header style={headerStyle}>
          <div>
            <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '900', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Hotel size={22} color="#2563eb" /> CATÉGORIES DE CHAMBRES
            </h1>
            <div style={{ color: '#64748b', fontSize: '13px' }}>
              Gestion des types d'hébergement (Standard, VIP, Suite...)
            </div>
          </div>
          <div>
            {!isAdding && !editingId && (
              <button 
                onClick={() => setIsAdding(true)} 
                style={btnPrimaryStyle}
              >
                <Plus size={18} /> Nouvelle Catégorie
              </button>
            )}
          </div>
        </header>

        <div style={{ padding: '30px 40px' }}>

          {(isAdding || editingId) && (
            <div style={{ ...contentCardStyle, padding: '25px', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '14px', marginBottom: '15px', fontWeight: '800' }}>
                {editingId ? 'Modifier la catégorie' : 'Ajouter une nouvelle catégorie'}
              </h3>
              <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '20px', alignItems: 'flex-end' }}>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>NOM DE LA CATÉGORIE</label>
                  <input 
                    type="text" 
                    style={inputStyle} 
                    placeholder="Ex: SUITE VIP"
                    value={formData.nom} 
                    onChange={(e) => setFormData({...formData, nom: e.target.value})} 
                    required 
                  />
                </div>
                <div style={{ flex: 2 }}>
                  <label style={labelStyle}>DESCRIPTION</label>
                  <input 
                    type="text" 
                    style={inputStyle} 
                    placeholder="Détails, équipements inclus..."
                    value={formData.description} 
                    onChange={(e) => setFormData({...formData, description: e.target.value})} 
                  />
                </div>
                <button type="submit" disabled={loading} style={btnSubmitStyle}>{loading ? '...' : 'Valider'}</button>
                <button type="button" onClick={closeForm} style={btnCancelStyle}>Annuler</button>
              </form>
            </div>
          )}

          <div style={contentCardStyle}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <th style={thStyle}>ID</th>
                  <th style={thStyle}>Nom de la Catégorie</th>
                  <th style={thStyle}>Description</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                      Aucune catégorie de chambre enregistrée.
                    </td>
                  </tr>
                ) : (
                  categories.map((item) => (
                    <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={tdStyle}><code style={codeStyle}>{item.id}</code></td>
                      <td style={{ ...tdStyle, fontWeight: '800', color: '#2563eb' }}>{item.nom}</td>
                      <td style={tdStyle}>{item.description || '---'}</td>
                      <td style={{ ...tdStyle, textAlign: 'right' }}>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                          <button 
                            onClick={() => {
                              setEditingId(item.id); 
                              setFormData({ nom: item.nom, description: item.description || '' }); 
                              setIsAdding(false);
                            }} 
                            style={actionBtnStyle('#2563eb')}
                          >
                            <Edit3 size={14}/>
                          </button>
                          
                          <button onClick={() => handleDeleteClick(item.id)} style={actionBtnStyle('#ef4444')}>
                            <Trash2 size={14}/>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {modalConfig.show && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
              <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '10px', borderRadius: '50%' }}><AlertTriangle size={24} /></div>
              <h2 style={{ margin: 0, fontSize: '18px' }}>Confirmation de suppression</h2>
            </div>
            <p style={{ color: '#475569', marginBottom: '30px' }}>{modalConfig.message}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setModalConfig({ show: false, action: null, message: '', id: null })} style={btnSecondaryStyle}>Annuler</button>
              <button onClick={modalConfig.action} style={btnDangerStyle}>
                {loading ? '...' : 'Supprimer'}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes slideInToast { from { transform: translate(-50%, -20px); opacity: 0; } to { transform: translate(-50%, 0); opacity: 1; } }`}</style>
    </div>
  );
};

// --- STYLES HARMONISÉS ---
const headerStyle = { background: 'white', padding: '20px 40px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const contentCardStyle = { background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', overflow: 'hidden' };
const btnPrimaryStyle = { background: '#2563eb', color: 'white', border: 'none', padding: '10px 22px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', fontWeight: '700' };
const btnSecondaryStyle = { border: '1px solid #e2e8f0', padding: '10px 15px', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', color: '#475569', background: 'white' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px', marginTop: '5px' };
const labelStyle = { fontSize: '11px', fontWeight: '900', color: '#475569' };
const thStyle = { padding: '15px 20px', fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '800', textAlign: 'left' };
const tdStyle = { padding: '12px 20px', fontSize: '13px', color: '#334155' };
const codeStyle = { fontSize: '11px', background: '#f1f5f9', padding: '2px 4px', borderRadius: '4px' };
const btnSubmitStyle = { padding: '0 25px', background: '#2563eb', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', height: '45px' };
const btnCancelStyle = { padding: '0 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', height: '45px' };
const actionBtnStyle = (color) => ({ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 15px', borderRadius: '8px', border: `1px solid ${color}30`, background: `${color}10`, color: color, fontSize: '11px', fontWeight: '900', cursor: 'pointer' });
const toastContainerStyle = { position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, color: 'white', padding: '12px 24px', borderRadius: '12px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)', display: 'flex', alignItems: 'center', gap: '10px', fontWeight: '800', animation: 'slideInToast 0.3s ease-out' };
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const modalContentStyle = { background: 'white', padding: '30px', borderRadius: '12px', width: '400px', maxWidth: '90%', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' };
const btnDangerStyle = { background: '#ef4444', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '700' };

export default CategorieChambre;